// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"28":"28980e9f","30":"0a72b164","71":"59f08946","265":"5faa6b35","376":"c8d089c3","514":"d800b871","623":"cc0ae8f0","784":"a517a0a6","785":"80e6bf3c","874":"773a6bf0","911":"45658b99","917":"4e6e2025"}[chunkId] + ".chunk.js";
};